module.exports = __webpack_public_path__ + "static/media/navy-blue-add-vehicle-btn.6d4a0fdd.svg";